/* 
  科目管理
*/
import request from "@/utils/request";

//获取职称列表
export function getProfessional() {
  return request({
    url: "/sysmanage/professional/list",
    method: "get"
  });
}

//添加或者编辑科目信息
export function saveOrUpdate(data) {
  return request({
    url: "/sysmanage/professional/saveOrUpdate",
    method: "post",
    data
  });
}

//删除科目
export function deleteProfessional(data) {
  return request({
    url: "/sysmanage/professional/del",
    method: "post",
    data
  });
}
